export default {
    title: "O-I",
    support: "Apoiar",
    dashboard: "Painel"
}